import React, { useState, useEffect } from 'react'
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../../firebase';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import AnnouncementIcon from '@mui/icons-material/Announcement';
import { useMediaQuery } from '@mui/material';

//theme
const themeColor = "#474aee"

const TipsSendt = () => {
  const isPhone = useMediaQuery('(max-width:600px)');
  const [totalDocuments, setTotalDocuments] = useState(0);
  useEffect(() => {
    const collectionRef = collection(db, 'tips');
    const fetchTotalDocuments = () => {
      const unsubscribe = onSnapshot(collectionRef, (snapshot) => {
        setTotalDocuments(snapshot.size);
      });
      return unsubscribe;
    };
    const unsubscribe = fetchTotalDocuments();
    return () => {
      unsubscribe();
    };
  }, []);

  //console.log(isPhone)
  return (
    <Card sx={isPhone ? { maxWidth: 300, minWidth: 300, } : { maxWidth: 345, minWidth: 300, }}>
      <CardHeader
        avatar={
          <Avatar sx={{ bgcolor: themeColor }} aria-label="recipe">
            <AnnouncementIcon />
          </Avatar>
        }
      />
      {
        isPhone ?
          <CardContent>
            <Typography variant="h5">
            Totalt innsendt : {totalDocuments}
            </Typography>
          </CardContent>
          :
          <CardContent>
            <Typography variant="h5">
            Totalt innsendt
            </Typography>
            <Typography variant="h5">
              {totalDocuments}
            </Typography>
          </CardContent>
      }

    </Card>
  )
}

export default TipsSendt